<template>
  <div>
    <div
      v-if="error"
      class="alert alert-danger"
    >
      <p>We weren't able to find that email</p>
    </div>
    <form
      autocomplete="off"
      method="post"
      @submit.prevent="login"
    >
      <div class="form-group">
        <label for="fp_email">
          Email
        </label>
        <input
          id="fp_email"
          v-model="email"
          type="text"
          class="form-control"
          placeholder="The Email you used to Register"
          required
        >
      </div>
      <button
        type="submit"
        class="btn btn-default btn-primary"
      >
        Send me my Username
      </button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: null,
      error: false,
    };
  },
  methods: {
    login() {
      const app = this;
      axios
        .post('/api/auth/forgotten/username', {
          email: app.email,
        })
        .then((response) => {
          console.log(response);
        });
    },
  },
};
</script>
